module.exports = __webpack_public_path__ + "static/img/banner_f006.98bb75e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_f006.jpg
// module id = 4Uzx
// module chunks = 40